import $ from 'jquery';

const ChangeProfileInfo=(data, url)=>{
    let response = false;
    $.ajax({
        url: url,
        type: 'POST',
        async: false,
        headers: {
            "Authorization": "Bearer " + localStorage.getItem("access_token"),
            "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
        },
        data: data,
        success: function (res) {
          if (res.success === true) {
            response = true;
          } else {
            response = false;
          }
        }
      });
      return response;
}
export default ChangeProfileInfo;


// WEBPACK FOOTER //
// ./src/sales-desk/header/ChangeProfileInfo.js